module.exports = __webpack_public_path__ + "img/IAR20.d4c026c4.png";